
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取讣告集合
    GetObituaryList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Obituary/GetObituaryList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取讣告详情
    GetObituaryDetail({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Obituary/GetObituaryDetail',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 发布讣告
    addGenericArticleFG({commit},payload){
        return new Promise((resolve,reject) => {

            api.post('/GenericArticle/AddGenericArticleFGVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
